module.exports = __webpack_public_path__ + "img/czsc_10.a8696894.png";